/**
 * Downscale an image file in the browser to fit within `maxWidth` x `maxHeight`
 * and re-encode it as a PNG data URL (PNG keeps transparency). Smaller images
 * are not upscaled.
 */
export const resizeImageToPngDataUrl = async (
    file: File,
    maxWidth = 800,
    maxHeight = 500
): Promise<string> => {
    const bitmap = await createImageBitmap(file);
    try {
        const scale = Math.min(1, maxWidth / bitmap.width, maxHeight / bitmap.height);
        const canvas = document.createElement("canvas");
        // floor, not round: rounding up could land one pixel past org_server's limit.
        canvas.width = Math.floor(bitmap.width * scale);
        canvas.height = Math.floor(bitmap.height * scale);
        const ctx = canvas.getContext("2d");
        if (!ctx) throw new Error("Canvas 2D context unavailable");
        ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL("image/png");
    } finally {
        bitmap.close();
    }
};
